import AccountNotificationIcon from '@/assets/svg/nav/account_notifications.svg';
import AdminIcon from '@/assets/svg/nav/admins.svg';
import ContentTeamIcon from '@/assets/svg/nav/content_team.svg';
import CategoryIcon from '@/assets/svg/nav/categories.svg';
import CountryIcon from '@/assets/svg/nav/countries.svg';
import CurrencyIcon from '@/assets/svg/nav/currencies.svg';
import GenerateReportIcon from '@/assets/svg/nav/generate_report.svg';
import HomePageIcon from '@/assets/svg/nav/home_page.svg';
import IssueIcon from '@/assets/svg/nav/issues.svg';
import LocaleIcon from '@/assets/svg/nav/locales.svg';
import MediaIcon from '@/assets/svg/nav/media.svg';
import MessageIcon from '@/assets/svg/nav/messages.svg';
import PaymentIcon from '@/assets/svg/nav/payment_provider.svg';
import AdPlacementIcon from '@/assets/svg/nav/ad_placement.svg';
import PaymentMethodIcon from '@/assets/svg/nav/payment_method.svg';
import PrivacyPolicyIcon from '@/assets/svg/nav/privacy_policy.svg';
import ProductIcon from '@/assets/svg/nav/products.svg';
import ReportedIssueIcon from '@/assets/svg/nav/reported_issues.svg';
import RoleIcon from '@/assets/svg/nav/roles.svg';
import SentNotificationIcon from '@/assets/svg/nav/send_notification.svg';
import SettingsIcon from '@/assets/svg/nav/settings.svg';
import TermsCondIcon from '@/assets/svg/nav/terms_cond.svg';
import UserIcon from '@/assets/svg/nav/users.svg';
import ViewReportIcon from '@/assets/svg/nav/view_report.svg';
import AboutUsIcon from '@/assets/svg/nav/page_builder.svg';
import ChatIcon from '@/assets/svg/nav/chat.svg';
import FaqIcon from '@/assets/svg/nav/faq.svg';
import LocationIcon from '@/assets/svg/nav/global.svg';
import FailedJobs from '@/assets/svg/nav/failed_jobs.svg';
import StoreIcon from '@/assets/svg/nav/store.svg';
import StoreType from '@/assets/svg/nav/store_type.svg';
import Jobs from '@/assets/svg/nav/jobs.svg';
import AuditLogs from '@/assets/svg/nav/double_check.svg';
import DashboardIcon from '@/assets/svg/nav/dashboard.svg';
import StorePackages from '@/assets/svg/nav/store-packages.svg';
import ProductPackages from '@/assets/svg/nav/product-packages.svg';
import ExpenseIcon from '@/assets/svg/nav/expenses.svg';
import ExportIcon from '@/assets/svg/nav/exports.svg';
import ImportIcon from '@/assets/svg/nav/import.svg';
import Flag from '@/assets/svg/nav/flag.svg';
import BoostStore from '@/assets/svg/nav/boost_store.svg';
import BoostProduct from '@/assets/svg/nav/boost_product.svg';
import NotificationPackage from '@/assets/svg/nav/notification_package.svg';

let adminMenu = [
  {
    title: 'dashboard',
    to: '/',
    icon: DashboardIcon,
    perm: 'dashboard.get',
  },
  {
    title: 'chat',
    to: 'chat',
    icon: ChatIcon,
    perm: 'chat.get',
  },
  //Store
  { heading: 'storeManager', perms: ['user', 'store', 'product', 'category'] },
  {
    title: 'users',
    to: 'users',
    icon: UserIcon,
    perm: 'user',
  },
  {
    title: 'store',
    to: 'store',
    icon: StoreIcon,
    perm: 'store',
  },
  {
    title: 'storeType',
    to: 'store-type',
    icon: StoreType,
    perm: 'store_type',
  },
  {
    title: 'products',
    to: 'products',
    icon: ProductIcon,
    perm: 'product',
  },
  {
    title: 'categories',
    to: 'categories',
    icon: CategoryIcon,
    perm: 'category',
  },

  // Packages
  {
    heading: 'packages',
    perms: [
      'store_package',
      'banner_package',
      'boost_store_package',
      'boost_product_package',
      'notification_package',
      'product_package',
      'store_subscription',
      'banner_subscription',
      'boost_store_subscription',
      'boost_product_subscription',
      'notification_subscription',
      'product_subscription',
    ],
  },
  {
    title: 'storePackages',
    to: 'store-packages',
    icon: StorePackages,
    perm: ['store_package', 'store_subscription'],
  },
  {
    title: 'bannerPackages',
    to: 'banner-packages',
    icon: Flag,
    perm: ['banner_package', 'banner_subscription'],
  },
  {
    title: 'boostStorePackages',
    to: 'boost-store-packages',
    icon: BoostStore,
    perm: ['boost_store_package', 'boost_store_subscription'],
  },
  {
    title: 'boostProductPackages',
    to: 'boost-product-packages',
    icon: BoostProduct,
    perm: ['boost_product_package', 'boost_product_subscription'],
  },
  {
    title: 'notificationPackages',
    to: 'notification-packages',
    icon: NotificationPackage,
    perm: ['notification_package', 'notification_subscription'],
  },
  {
    title: 'productPackages',
    to: 'product-packages',
    icon: ProductPackages,
    perm: ['product_package', 'product_subscription'],
  },

  // Operations
  { heading: 'operations', perms: ['issue', 'predefined_issue', 'contact_us', 'win_item'] },
  {
    title: 'reportedIssues',
    to: 'issues',
    icon: ReportedIssueIcon,
    perm: 'issue',
  },
  {
    title: 'predefinedIssues',
    to: 'predefined-issues',
    icon: IssueIcon,
    perm: 'predefined_issue',
  },
  {
    title: 'messages',
    to: 'contact-us',
    icon: MessageIcon,
    perm: 'contact_us',
  },
  {
    title: 'adPlacement',
    to: 'ad-placement',
    icon: AdPlacementIcon,
    perm: 'ad_placement',
  },
  {
    title: 'winItems',
    to: 'win-items',
    icon: AboutUsIcon,
    perm: 'win_item',
  },

  // Report
  { heading: 'reports', perms: ['report_query', 'report_view'] },
  {
    title: 'generateReports',
    to: 'generate-report',
    icon: GenerateReportIcon,
    perm: 'report_query',
  },
  {
    title: 'viewReports',
    to: 'view-report',
    icon: ViewReportIcon,
    perm: 'report_view',
  },

  // Notification
  { heading: 'notification', perms: ['send_notification'] },
  {
    title: 'accountNotifications',
    to: 'notifications',
    icon: AccountNotificationIcon,
  },
  {
    title: 'sendNotifications',
    to: 'send-notifications',
    icon: SentNotificationIcon,
    perm: 'send_notification',
  },

  // accounts
  { heading: 'administration', perms: ['admin', 'content_team', 'role', 'expense'] },
  {
    title: 'admins',
    to: 'admins',
    icon: AdminIcon,
    perm: 'admin',
  },
  {
    title: 'contentTeam',
    to: 'content-team',
    icon: ContentTeamIcon,
    perm: 'content_team.get',
  },
  {
    title: 'rolesAndPermissions',
    to: 'roles-and-permissions',
    icon: RoleIcon,
    perm: 'role',
  },
  {
    title: 'expenses',
    to: 'expenses',
    icon: ExpenseIcon,
    is_custom: true,
    perm: 'expense',
  },

  // Providers
  { heading: 'providers', perms: ['payment_method', 'payment_provider'] },
  {
    title: 'paymentMethod',
    to: 'payment-method',
    icon: PaymentMethodIcon,
    perm: 'payment_method',
  },
  {
    title: 'paymentProvider',
    to: 'payment-providers',
    icon: PaymentIcon,
    perm: 'payment_provider',
  },
  { heading: 'system', perms: ['export', 'import', 'jobs', 'failed_jobs', 'audit_log'] },
  {
    title: 'auditLogs',
    to: 'audit-logs',
    icon: AuditLogs,
    perm: 'audit_log',
  },
  {
    title: 'jobs',
    to: 'jobs',
    icon: Jobs,
    perm: 'jobs',
  },
  {
    title: 'failedJobs',
    to: 'failed-jobs',
    icon: FailedJobs,
    perm: 'failed_jobs',
  },
  {
    title: 'exports',
    to: 'exports',
    icon: ExportIcon,
    is_custom: true,
    fillCls: 'svg-fill-transperant',
    perm: 'export',
  },
  {
    title: 'imports',
    to: 'imports',
    icon: ImportIcon,
    is_custom: true,
    fillCls: 'svg-fill-transperant',
    perm: 'import',
  },

  // Configurations
  { heading: 'configurations', perms: ['attachment', 'home_page.get', 'settings.privacy_policy', 'settings.terms_cond', 'settings.about_us'] },
  {
    title: 'homePage',
    to: 'home-page',
    icon: HomePageIcon,
    perm: 'home_page.get',
  },
  {
    title: 'privacyPolicy',
    to: 'privacy-policy',
    icon: PrivacyPolicyIcon,
    perm: 'settings.privacy_policy',
  },
  {
    title: 'termsAndCondition',
    to: 'terms-cond',
    icon: TermsCondIcon,
    perm: 'settings.terms_cond',
  },
  {
    title: 'mediaLibrary',
    to: 'media',
    icon: MediaIcon,
    perm: 'attachment',
  },

  // settings
  { heading: 'settings', perms: ['location', 'faq', 'currency', 'locale', 'country', 'settings.general_settings'] },
  {
    title: 'locations',
    to: 'locations',
    icon: LocationIcon,
    perm: 'location',
  },
  {
    title: 'faqs',
    to: 'faq',
    icon: FaqIcon,
    perm: 'faq',
  },
  {
    title: 'currencies',
    to: 'currencies',
    icon: CurrencyIcon,
    perm: 'currency',
  },
  {
    title: 'locales',
    to: 'locales',
    icon: LocaleIcon,
    perm: 'locale',
  },
  {
    title: 'countries',
    to: 'countries',
    icon: CountryIcon,
    perm: 'country',
  },
  {
    title: 'settings',
    to: 'settings',
    icon: SettingsIcon,
    perm: 'settings.general_settings',
  },
];

export default adminMenu;
